import { render, staticRenderFns } from "./addProvider.vue?vue&type=template&id=58df4533&lang=pug&"
import script from "./addProvider.vue?vue&type=script&lang=js&"
export * from "./addProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports